import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

interface HeaderSearchLocationState {
  itemId?: string;
}

export const useHeaderSearchValue = () => {
  const location = useLocation<HeaderSearchLocationState>();
  const itemId = location.state && location.state.itemId;

  const resetLocationState = useCallback(() => {
    const locationStateCopy = { ...location.state };
    delete locationStateCopy.itemId;
    window.history.replaceState(
      { ...location, state: locationStateCopy },
      document.title,
    );
  }, [location]);

  return { itemId, resetLocationState };
};
